import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import PageHeader from "components/PageHeader/Pageheader";
import BookingTypeCards from "./BookingTypeCards";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { approvalPolicySchema } from "constants/formValidation";
import { useEffect, useState } from "react";
import ApprovalForm from "./ApprovalForm";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import { getUserConfig, saveUserConfig } from "slices/userReducer";
import { ROUTES } from "constants/routes";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getAddress } from "slices/addressReducer";

const ApprovalPolicy = () => {
  const { control, handleSubmit, setValue, getValues, setError } = useForm({
    mode: "onChange",
    resolver: yupResolver(approvalPolicySchema),
  });
  const { userReducer }: any = useAppSelector((state) => state);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [selectedAddress, setSelectedAddress] = useState(null);
  const { userConfigLoading } = userReducer;
  let [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    dispatch(getUserConfig());
    // dispatch(getAddress());
  }, [dispatch]);

  useEffect(() => {
    if (userReducer.userConfig) {
      const {
        approval_policy_type,
        offer_delv_pickup,
        min_delv_pickup_fees,
        offer_operator_service,
        min_operator_fee,
        max_operator_fee,
        security_deposit,
        listing_address,
        max_delv_distance,
      } = userReducer.userConfig;
      setValue("approval_policy_type", approval_policy_type ?? null);
      setValue("offer_delv_pickup", offer_delv_pickup ?? null);
      setValue("max_delv_distance", max_delv_distance || undefined);
      setValue("min_delv_pickup_fees", min_delv_pickup_fees || undefined);
      setValue("offer_operator_service", offer_operator_service ?? null);
      setValue("min_operator_fee", min_operator_fee || undefined);
      setValue("max_operator_fee", max_operator_fee || undefined);
      setValue("security_deposit", security_deposit || undefined);

      setValue("addressLine1", listing_address?.address_line_1);
      setValue("addressLine2", listing_address?.address_line_2);
      setValue("city", listing_address?.city);
      setValue("state", listing_address?.state);
      setValue("zipcode", listing_address?.zipcode);
      // setSelectedAddress(listing_address?.id || null);
    }
  }, [userReducer.userConfig, setValue]);

  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down("md"));

  const submitForm = (data: any) => {
    dispatch(
      saveUserConfig({
        data: {
          ...data,

          approval_policy_type: Number(data.approval_policy_type),
          ...(Number(data.offer_delv_pickup) === 1
            ? {
                offer_delv_pickup: 1,
                min_delv_pickup_fees: parseFloat(data.min_delv_pickup_fees),
                max_delv_distance: parseFloat(data.max_delv_distance),
              }
            : {
                offer_delv_pickup: 0,
                min_delv_pickup_fees: 0,
                max_delv_distance: 0,
              }),
          ...(Number(data.offer_operator_service) === 1
            ? {
                offer_operator_service: 1,
                min_operator_fee: parseFloat(data.min_operator_fee),
                max_operator_fee: parseFloat(data.max_operator_fee),
              }
            : {
                offer_operator_service: 0,
                min_operator_fee: 0,
                max_operator_fee: 0,
              }),
          security_deposit: parseFloat(data.security_deposit),
          // address_id:selectedAddress,
        },
        onSuccess: () => {
          const backTo = searchParams.get("backTo");
          navigate(backTo?.length ? backTo : ROUTES.HOME);
        },
      })
    );
  };
  return (
    <Box>
      <PageHeader title="Approval Policy" navPath={"/"} />
      <form onSubmit={handleSubmit(submitForm)}>
        <Box p={2.5}>
          <Grid container spacing={2} alignItems="stretch">
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={4}
              xl={4}
              sx={{
                backgroundColor: isMobileView ? "#fff" : "#F4F4F4",
                px: isMobileView ? 0 : 4,
                py: isMobileView ? 1.5 : 3,
              }}
            >
              {!isMobileView && (
                <Typography fontSize={18} fontWeight={600}>
                  How would you like to approve your Rental Requests?
                </Typography>
              )}
              <br />
              <BookingTypeCards
                control={control}
                direction={isMobileView ? "row" : "column"}
                userConfigLoading={userConfigLoading}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={9} lg={8} xl={8}>
              <ApprovalForm
                control={control}
                getValues={getValues}
                setValue={setValue}
                selectedAddress={selectedAddress}
                setSelectedAddress={setSelectedAddress}
                userConfigLoading={userConfigLoading}
              />
            </Grid>
          </Grid>
        </Box>
      </form>
    </Box>
  );
};

export default ApprovalPolicy;
